import { AxiosResponse } from 'axios'
import { useEffect } from 'react'

import { RecordNotFoundError } from '../../models/errors/RecordNotFoundError'
import ErrorRecordNotFound from './ErrorRecordNotFound'
import Button from './design/Button'
import Modal from './design/Modal'
import Paragraph from './design/Paragraph'

type Props = {
    error?: AxiosResponse | Error
    resetErrorBoundary: (...args: Array<unknown>) => void
}

export const ErrorFallback = ({ error, resetErrorBoundary }: Props) => {
    useEffect(() => {
        document.getElementById('root-spinner')?.remove()
    }, [])

    const message: string = error instanceof Error ? error.message : error?.data?.message
    const errorMessage =
        message ||
        "We're sorry, something went wrong.  If the error persists, please contact support."

    if (error instanceof RecordNotFoundError) {
        return <ErrorRecordNotFound resetErrorBoundary={resetErrorBoundary} />
    }

    return (
        <>
            <Modal
                isOpen
                onClose={resetErrorBoundary}
                size="small"
                title="Error"
                showDividers={false}
                footer={
                    <Button intent="primary" onClick={resetErrorBoundary}>
                        Dismiss
                    </Button>
                }
            >
                <div className="mt-4 text-gray-600">
                    <Paragraph>{errorMessage}</Paragraph>
                </div>
            </Modal>
        </>
    )
}
